export class CelebrationPlace {
  private _place: string

  constructor (place: string) {
    if (place === '') {
      throw new TypeError('Celebration Place can\'t be empty')
    }
    this._place = place
  }

  place (): string {
    return this._place
  }
}
